import { useState } from 'react'
import { AdviceScreen } from './advice-screen'
import { fetchArticlesQuery, useArticlesQuery, useBlogHomeQuery } from './queries'

export interface AdviceScreenContainerProps {
  preview?: boolean
}

export const AdviceScreenContainer = (props: AdviceScreenContainerProps) => {
  const [refreshing, setRefreshing] = useState(false)
  const { loading, data, refetch: refetchHome } = useBlogHomeQuery({
    draft: !!props.preview,
  })
  const {
    data: dataArticles,
    fetchMore,
    refetch: refetchArticles,
    networkStatus,
  } = useArticlesQuery(fetchArticlesQuery.defaultVariables, {
    notifyOnNetworkStatusChange: true,
  })

  const handlePullToRefresh = async () => {
    setRefreshing(true)
    await Promise.all([refetchHome(), refetchArticles()])
    setRefreshing(false)
  }

  const handleLoadMore = () => {
    fetchMore({
      variables: {
        page: (dataArticles?.Articles?.page || 0) + 1,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return prev
        }
        return {
          Articles: {
            ...fetchMoreResult.Articles,
            docs: [...(prev.Articles?.docs || []), ...(fetchMoreResult.Articles?.docs || [])],
          },
        }
      },
    })
  }

  const hasMore = (dataArticles?.Articles?.page || 0) < (dataArticles?.Articles?.totalPages || 0)

  const fetchingMore = networkStatus === 3

  return (
    <AdviceScreen
      loading={loading}
      fetchingMore={fetchingMore}
      hasArticles={(data?.Articles?.totalDocs || 0) > 0 && !loading}
      hasMore={hasMore}
      content={data?.BlogHome?.content || []}
      meta={data?.BlogHome?.meta}
      moreArticles={dataArticles?.Articles?.docs || []}
      onLoadMore={handleLoadMore}
      refreshing={refreshing}
      onPullToRefresh={handlePullToRefresh}
    />
  )
}
